import {
  BoxExpand,
  ICONS,
  Icon,
  Loader,
  PLATFORM_THEME_COLORS,
  Separator,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';
import { useGetKWPConnectionByUserId } from 'src/hooks/interfaces/kwp/get-kwp-connection.hook';
import BoxExpandButtons from './kwp-box-expand-buttons.component';

const KWPBoxExpand = ({ createElement, canEdit }: any) => {
  const { t } = useTranslation('common');
  const { interfaceConnection, loading } = useGetKWPConnectionByUserId();

  if (loading) return <Loader />;
  return (
    <>
      <BoxExpand
        title="KWP"
        buttons={
          <BoxExpandButtons
            createButtonTxt={t(canEdit ? 'buttons.edit' : 'buttons.connect')}
            createElement={createElement}
            canEdit={canEdit}
          />
        }
      >
        {canEdit ? (
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <Typography weight="bold" style={{ marginRight: '5px' }}>
              API Link:{' '}
            </Typography>
            <Icon
              cursorPointer
              icon={ICONS.copy}
              size={16}
              color={PLATFORM_THEME_COLORS.primary.blue}
              onClick={() => navigator.clipboard.writeText(interfaceConnection.link)}
            />
          </div>
        ) : (
          <Typography>{t('labels.notValidToken')}</Typography>
        )}
      </BoxExpand>
      <Separator />
    </>
  );
};

export default KWPBoxExpand;
